import { ApiSlugs, TokenVaultId, TokenVaultResetUserPasswordDto } from '@workspace/data-types';
import { ApiCaller } from '../../../api-caller.service';
import { TokenVaultsUserRegistrationConnector } from './user-registration/token-vaults-user-registration.connector';

export class TokenVaultsAuthConnector {
  private slug = ApiSlugs.TOKEN_VAULTS;

  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  userRegistrations = () => new TokenVaultsUserRegistrationConnector(this.apiCaller, this.slug, this.prefix);

  tokenVault = (tokenVaultId: TokenVaultId) => {
    if (!tokenVaultId) {
      throw new Error('No tokenVaultId provided while calling API user token vault endpoint');
    }
    const tokenVaultUrl = `${this.slug}/${tokenVaultId}`;
    return {
      resetPassword: (tokenVaultResetUserPasswordDto: TokenVaultResetUserPasswordDto) =>
        this.apiCaller.postRequest<boolean>(
          this.prefix,
          `${tokenVaultUrl}/reset-password`,
          tokenVaultResetUserPasswordDto,
        ),
    };
  };
}
